import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import { magazineIssueEditFragment } from '../../fragments/MagazineIssueEdit.fragment'

import type {
    MagazineIssueEditQuery,
    MagazineIssueEditQueryVariables,
} from './Edit.queries.generated'

export const GET_ISSUE_EDIT = gql`
    query MagazineIssueEdit($guid: String!) {
        entity(guid: $guid) {
            guid
            ...MagazineIssueEdit
        }
    }
    ${magazineIssueEditFragment}
` as TypedDocumentNode<MagazineIssueEditQuery, MagazineIssueEditQueryVariables>
